module.exports = __webpack_public_path__ + "495aa5b6.png";